import { Breadcrumbs } from '@mui/material';
import styled from 'styled-components';

export const BreadcrumbItem = styled.span`
  color: ${({ theme }) =>
    theme.mode === 'light' ? '#3a3a3a' : theme.colors.primary.light};
`;

export const Container = styled.div`
  margin-left: 1dvw;
  height: 6dvh;
`;

export const BreadcrumbConteiner = styled(Breadcrumbs)`
  & ol {
    color: ${({ theme }) =>
      theme.mode === 'light' ? '#3a3a3a' : theme.colors.primary.light};
  }
`;
